import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            title: '',
            userTitle: '',
            id: 0,
            userId: 0,
            fromDate: null,
            toDate: null,
            companies: [],
            currentDate: new Date(),
            currentWeek: '',
            week: [],
            showAddDefinition: false,
            showChooseDefinition: false,
            addDefinitionDate: '',
            definitionDataToEdit: null,
            chooseDefinitionDate: '',
            startDate: '',
            endDate: '',
            copyTrainingForDate: false,
            copyTrainingForDateItem: null,
            dragDayDate: null,
            dragItemId: null,
            dragOverDayDate: null,
            dragOverTargetId: null,
            dragOverPosition: null,
            dirtyDayMap: {},
            dayOrderBaseline: {},
            isSavingDayOrder: {}
        }
    },
    methods: {
        getStartOfWeek: getStartOfWeek,
        getDayOfWeek: getDayOfWeek,
        getPersonalProgramById: getPersonalProgramById,
        formatDate: formatDate,
        parseDate: parseDate,
        isEnableDate: isEnableDate,
        editDefinitionData: editDefinitionData,
        displayWeek: displayWeek,
        deleteTrainingOfTheDay: deleteTrainingOfTheDay,
        getTrainingOfTheDayForPeriod: getTrainingOfTheDayForPeriod,
        showDefinitionAdd: showDefinitionAdd,
        changeWeek: changeWeek,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        copyTrainingForDates: copyTrainingForDates,
        getGroupedDayDetails: getGroupedDayDetails,
        getTrainingThumb: getTrainingThumb,
        onDayTrainingDragStart: onDayTrainingDragStart,
        onDayTrainingDragOver: onDayTrainingDragOver,
        onDayTrainingDrop: onDayTrainingDrop,
        onDayTrainingDragEnd: onDayTrainingDragEnd,
        isDropZoneVisible: isDropZoneVisible,
        isDropZoneActive: isDropZoneActive,
        getLastDayTraining: getLastDayTraining,
        moveDayTrainingByStep: moveDayTrainingByStep,
        canMoveDayTraining: canMoveDayTraining,
        isDayDirty: isDayDirty,
        saveDayOrder: saveDayOrder
    },

    created() {

        this.$topnavbar.$on('closeTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
        });

        this.$topnavbar.$on('successTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.getTrainingOfTheDayForPeriod();
        });

        this.$topnavbar.$on('chooseExistTraining', (data) => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.showChooseDefinition = true
            this.chooseDefinitionDate = data
        });

        this.$topnavbar.$on('closeChooseDefinition', () => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
        });

        this.$topnavbar.$on('onTrainingDefinitionSelected', (data) => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
            this.getTrainingOfTheDayForPeriod();
        });

        this.$topnavbar.$on('closeCopyTraining', () => {
            this.copyTrainingForDate = false
            this.copyTrainingForDateItem = null
        });

        this.$topnavbar.$on('successCopyTraining', () => {
            this.copyTrainingForDate = false
            this.copyTrainingForDateItem = null
            this.getTrainingOfTheDayForPeriod();
        });

        this._globalDragReset = () => {
            onDayTrainingDragEnd.call(this);
        };
        window.addEventListener('dragend', this._globalDragReset);
        window.addEventListener('drop', this._globalDragReset);

    },

    beforeDestroy() {
        if (this._globalDragReset) {
            window.removeEventListener('dragend', this._globalDragReset);
            window.removeEventListener('drop', this._globalDragReset);
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.id = this.$route.query.id;
        this.userId = this.$route.query.userId;
        this.role = session.getRole();
        this.getPersonalProgramById();
        this.displayWeek();
    }
}

function copyTrainingForDates(item){
    this.copyTrainingForDate = true;
    this.copyTrainingForDateItem = item;
}

function getPersonalProgramById(){
    let _self = this;
    AdminApiService.getPersonalProgramById(this.id, false)
        .then((response) => {
            let data = response.data.details;

            _self.fromDate = _self.$moment(data.startTime * 1000).format('DD-MM-YYYY');
            _self.toDate = _self.$moment(data.endTime * 1000).format('DD-MM-YYYY');
            _self.title = _self.getName(data) + " ( "+_self.fromDate + " " + "->" +" " +  _self.toDate + " ) "
            _self.userTitle =  data.firstName + " " + data.lastName + " ( "+data.username + " ) ";
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function showDefinitionAdd(item){
    this.definitionDataToEdit = null
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function editDefinitionData(item){
    this.definitionDataToEdit = item
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function getStartOfWeek(date) {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    return new Date(date.setDate(diff));
}

// Funkcija za formatiranje datuma
function formatDate(date) {
    return this.$moment(date).format('DD-MM-YYYY')
    // return date.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    // });
}


// Funkcija za prikaz trenutne nedelje u kontejnerima
function displayWeek() {

    const startOfWeek = getStartOfWeek(new Date(this.currentDate));
    this.week = [];
    for (let i = 0; i < 7; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        this.week.push({
            date: this.formatDate(currentDay),
            details: []
        })
        // weekContainer.children[i].textContent = formatDate(currentDay);
    }

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    this.startDate = this.formatDate(startOfWeek);
    this.endDate = this.formatDate(endOfWeek);
    this.currentWeek = ` ${this.startDate} - ${this.endDate}`;
    this.getTrainingOfTheDayForPeriod();
}

// Funkcija za promenu nedelje
function changeWeek(offset) {
    this.week = [];
    this.currentDate.setDate(this.currentDate.getDate() + offset * 7);
    this.displayWeek();
}

function getTrainingOfTheDayForPeriod(){
    let model = {
        fromDate: this.startDate,
        toDate: this.endDate,
        type: "PERSONAL",
        programId: this.id
    }

    AdminApiService.getTrainingOfTheDayForPeriod(model)
        .then((response) => {
            this.week.forEach(w => {w.details = [];})
            response.data.forEach(dateObj => {

                const item = this.week.find(entry => entry.date === dateObj.date);
                if (item) {
                    item.details.push(dateObj);
                }
            });
            initDayOrderState.call(this);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function deleteTrainingOfTheDay(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_training_of_the_day"),
        text: LocService.t("label_delete_training_of_the_day_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTrainingOfTheDay(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_training_of_the_day_successfully'), 'success')
                _self.getTrainingOfTheDayForPeriod();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })

    })
}


function parseDate(dateString) {
    if(dateString == null) return new Date();
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // Mjeseci u JS počinju od 0 (0 = januar)
}

function isEnableDate(dateToCheck){
    const date1 = parseDate(dateToCheck);
    const startTime = parseDate(this.fromDate);
    const endTime = parseDate(this.toDate);
    let isActive = date1 >= startTime && date1 <= endTime
    return isActive;
}

function getDayOfWeek(dateString) {
    const [day, month, year] = dateString.split("-").map(Number);

    const date = new Date(year, month - 1, day);

    const daysOfWeek = [
        LocService.t('day_sunday'),
        LocService.t('day_monday'),
        LocService.t('day_tuesday'),
        LocService.t('day_wednesday'),
        LocService.t('day_thursday'),
        LocService.t('day_friday'),
        LocService.t('day_saturday')];

    // Dohvatanje dana u nedelji i ispis
    return daysOfWeek[date.getDay()];
}

function getGroupedDayDetails(details) {
    const items = Array.isArray(details) ? details : [];
    const countBySuperSet = {};

    items.forEach(item => {
        const superSetId = normalizeSuperSetId(item);
        if (superSetId !== '') {
            countBySuperSet[superSetId] = (countBySuperSet[superSetId] || 0) + 1;
        }
    });

    const grouped = [];
    const groupMap = {};

    items.forEach((item, index) => {
        const superSetId = normalizeSuperSetId(item);
        const shouldGroup = superSetId !== '' && countBySuperSet[superSetId] >= 2;

        if (!shouldGroup) {
            grouped.push({
                key: 'single-' + (item.id != null ? item.id : index),
                isSuperSet: false,
                items: [item]
            });
            return;
        }

        if (!groupMap[superSetId]) {
            const groupName = getSuperSetName(item);
            groupMap[superSetId] = {
                key: 'superset-' + superSetId + '-' + index,
                isSuperSet: true,
                superSetId: superSetId,
                superSetName: groupName,
                items: []
            };
            grouped.push(groupMap[superSetId]);
        }

        groupMap[superSetId].items.push(item);
    });

    return grouped;
}

function normalizeSuperSetId(item) {
    if (item == null) return '';
    const raw = item.superSetId;
    if (raw == null || raw === '') return '';
    return String(raw);
}

function getSuperSetName(item) {
    if (item == null) return 'SuperSet';
    if (item.superSetName != null && String(item.superSetName).trim().length > 0) {
        return item.superSetName;
    }
    return 'SuperSet';
}

function onDayTrainingDragStart(day, detailsItem, event){
    if(day == null || detailsItem == null) return;
    onDayTrainingDragEnd.call(this);
    this.dragDayDate = day.date;
    this.dragItemId = detailsItem.id;
    if(event && event.dataTransfer){
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', '' + detailsItem.id);
    }
}

function onDayTrainingDragOver(day, detailsItem, event){
    if(day == null || detailsItem == null || event == null) return;
    if(this.dragDayDate !== day.date) return;
    event.preventDefault();
    if(event.dataTransfer){
        event.dataTransfer.dropEffect = 'move';
    }
    const rect = event.currentTarget != null && event.currentTarget.getBoundingClientRect
        ? event.currentTarget.getBoundingClientRect()
        : null;
    let position = 'before';
    if(rect != null){
        const midY = rect.top + (rect.height / 2);
        position = event.clientY >= midY ? 'after' : 'before';
    }
    this.dragOverDayDate = day.date;
    this.dragOverTargetId = detailsItem.id;
    this.dragOverPosition = position;
}

function onDayTrainingDrop(day, targetItem, event){
    if(event != null) event.preventDefault();
    if(day == null || targetItem == null) return;
    if(this.dragDayDate !== day.date || this.dragItemId == null) return;

    const list = Array.isArray(day.details) ? day.details : [];
    const fromIndex = list.findIndex(i => i.id === this.dragItemId);
    let targetIndex = list.findIndex(i => i.id === targetItem.id);
    if(fromIndex < 0 || targetIndex < 0){
        onDayTrainingDragEnd.call(this);
        return;
    }

    const position = this.dragOverPosition === 'after' ? 'after' : 'before';
    if(position === 'after'){
        targetIndex += 1;
    }

    const moved = list.splice(fromIndex, 1)[0];
    if(fromIndex < targetIndex){
        targetIndex -= 1;
    }
    if(targetIndex < 0) targetIndex = 0;
    if(targetIndex > list.length) targetIndex = list.length;
    list.splice(targetIndex, 0, moved);
    markDayDirty.call(this, day);
    onDayTrainingDragEnd.call(this);
}

function onDayTrainingDragEnd(){
    this.dragDayDate = null;
    this.dragItemId = null;
    this.dragOverDayDate = null;
    this.dragOverTargetId = null;
    this.dragOverPosition = null;
}

function isDropZoneVisible(day){
    if(day == null || day.date == null) return false;
    return this.dragDayDate === day.date && this.dragItemId != null;
}

function isDropZoneActive(day, targetItem, position){
    if(day == null || targetItem == null) return false;
    return this.dragOverDayDate === day.date
        && this.dragOverTargetId === targetItem.id
        && this.dragOverPosition === position;
}

function getLastDayTraining(day){
    const items = day != null && Array.isArray(day.details) ? day.details : [];
    if(items.length === 0) return null;
    return items[items.length - 1];
}

function canMoveDayTraining(day, item, direction){
    if(day == null || item == null || !Array.isArray(day.details)) return false;
    const idx = day.details.findIndex(i => i.id === item.id);
    if(idx < 0) return false;
    if(direction < 0) return idx > 0;
    if(direction > 0) return idx < day.details.length - 1;
    return false;
}

function moveDayTrainingByStep(day, item, direction){
    if(day == null || item == null || !Array.isArray(day.details)) return;
    if(direction !== -1 && direction !== 1) return;
    const idx = day.details.findIndex(i => i.id === item.id);
    if(idx < 0) return;
    const targetIdx = idx + direction;
    if(targetIdx < 0 || targetIdx >= day.details.length) return;

    const moved = day.details.splice(idx, 1)[0];
    day.details.splice(targetIdx, 0, moved);
    markDayDirty.call(this, day);
}

function isDayDirty(day){
    if(day == null || day.date == null) return false;
    return this.dirtyDayMap[day.date] === true;
}

function saveDayOrder(day){
    if(day == null || day.date == null) return;
    if(!this.isDayDirty(day)) return;
    if(this.isSavingDayOrder[day.date] === true) return;

    const items = Array.isArray(day.details) ? day.details : [];
    const payload = items.map((item, index) => ({
        trainingOfTheDayId: item.id,
        orderNumber: index + 1
    }));

    if(payload.length === 0) return;

    this.$set(this.isSavingDayOrder, day.date, true);
    AdminApiService.updateTrainingOfTheDayOrderNumbers(payload)
        .then(() => {
            items.forEach((item, idx) => {
                item.orderNumber = idx + 1;
            });
            this.$set(this.dayOrderBaseline, day.date, buildDayOrderSignature(day));
            this.$set(this.dirtyDayMap, day.date, false);
            swal(LocService.t('label_success'), LocService.t('label_success_updated'), 'success');
            this.$set(this.isSavingDayOrder, day.date, false);
        })
        .catch(error => {
            restoreDayOrderFromBaseline.call(this, day);
            const msg = error != null && error.data != null && error.data.localized_error_message
                ? error.data.localized_error_message
                : LocService.t('label_error');
            swal(LocService.t('label_error'), msg, 'error');
            this.$set(this.isSavingDayOrder, day.date, false);
        });
}

function initDayOrderState(){
    const baseline = {};
    const dirtyMap = {};
    const savingMap = {};

    this.week.forEach(day => {
        baseline[day.date] = buildDayOrderSignature(day);
        dirtyMap[day.date] = false;
        savingMap[day.date] = false;
    });

    this.dayOrderBaseline = baseline;
    this.dirtyDayMap = dirtyMap;
    this.isSavingDayOrder = savingMap;
}

function markDayDirty(day){
    if(day == null || day.date == null) return;
    const current = buildDayOrderSignature(day);
    const base = this.dayOrderBaseline[day.date] || '';
    this.$set(this.dirtyDayMap, day.date, current !== base);
}

function restoreDayOrderFromBaseline(day){
    if(day == null || day.date == null) return;
    const signature = this.dayOrderBaseline[day.date];
    if(signature == null || signature.length === 0) return;
    const orderIds = signature.split('|').map(v => parseInt(v, 10)).filter(v => !Number.isNaN(v));
    const map = {};
    (day.details || []).forEach(item => {
        map[item.id] = item;
    });
    const restored = [];
    orderIds.forEach(id => {
        if(map[id]) restored.push(map[id]);
    });
    (day.details || []).forEach(item => {
        if(orderIds.indexOf(item.id) < 0){
            restored.push(item);
        }
    });
    day.details = restored;
    this.$set(this.dirtyDayMap, day.date, false);
}

function buildDayOrderSignature(day){
    const ids = (day != null && Array.isArray(day.details) ? day.details : [])
        .map(item => item.id);
    return ids.join('|');
}

function getTrainingThumb(item){
    if(item == null) return '';
    if(item.imageUrl != null && item.imageUrl.length > 0) return item.imageUrl;
    const youtubeThumb = getYoutubeThumbnail(item.videoUrl);
    if(youtubeThumb != null && youtubeThumb.length > 0) return youtubeThumb;
    return '';
}

function getYoutubeThumbnail(url){
    if(url == null || ('' + url).trim().length === 0) return '';
    const raw = ('' + url).trim();
    let id = '';

    const embedMatch = raw.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/);
    if(embedMatch && embedMatch[1]) id = embedMatch[1];

    if(id.length === 0){
        const watchMatch = raw.match(/[?&]v=([a-zA-Z0-9_-]{6,})/);
        if(watchMatch && watchMatch[1]) id = watchMatch[1];
    }

    if(id.length === 0){
        const shortMatch = raw.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/);
        if(shortMatch && shortMatch[1]) id = shortMatch[1];
    }

    if(id.length === 0) return '';
    return 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
}



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalAdminProgram.js